import { render, staticRenderFns } from "./FileForm.vue?vue&type=template&id=6cf33aef&scoped=true&"
import script from "./FileForm.vue?vue&type=script&lang=ts&"
export * from "./FileForm.vue?vue&type=script&lang=ts&"
import style0 from "./FileForm.vue?vue&type=style&index=0&id=6cf33aef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf33aef",
  null
  
)

export default component.exports